<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="reload()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="订单编号：">
        <order-drop v-model="dataForm.orderCode" size="mini"></order-drop>
      </el-form-item>
      <el-form-item label="开票方：">
        <el-input v-model="dataForm.sellerName" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item prop="receiptCode" label="发票号：">
        <el-input v-model="dataForm.receiptCode" size="mini" clearable type="text"></el-input>
      </el-form-item>

      <el-form-item prop="productCode" label="品番号：" v-if="pageType==='product'">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：" v-if="pageType==='product'">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" label="中文品名：" v-if="pageType==='product'">
        <el-input
            v-model="dataForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" :label="productNameLabel+'：'">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            :placeholder="productNameLabel+'：'"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：" v-if="pageType==='material'">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：" v-if="pageType==='material'">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="克重"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload()" size="mini">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="margin-bottom: 0;">
      <el-button class="bar-item" type="warning" @click="showSaveDialog()" size="mini">发票导入</el-button>
    </div>
    <SweetTable ref="table" url="/erp/receipt/detail/page" :before-table-binding="beforeTableBinding" api-version="v2"
                :query-form="dataForm" :summaries-column="['count','totalAmount']" :auto-load="false">
      <el-table-column prop="orderCode" label="订单编号" align="center" header-align="center" fixed="left">
      </el-table-column>
      <el-table-column prop="receiptCode" label="发票号" align="center" header-align="center" fixed="left">
      </el-table-column>
      <el-table-column prop="sellerName" label="开票户头" align="center" header-align="center"
                       :formatter="$c.companyNameFormatter" fixed="left" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="operateDate" label="开票时间" align="center" width="100" header-align="center"
                       fixed="left">
      </el-table-column>
      <el-table-column prop="product.code" label="品番号" align="center" header-align="center"
                       :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="product.skuCode" label="SKU" align="center" header-align="center"
      ></el-table-column>
      <el-table-column prop="product.name" :label="productNameLabel" align="center" :show-overflow-tooltip="true"
                       header-align="center" v-if="pageType==='product'"></el-table-column>
      <el-table-column prop="product.color" label="颜色" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="product.size" label="规格" align="center"
                       header-align="center"></el-table-column>
      <el-table-column prop="product.attr1" label="幅宽" align="center"
                       header-align="center" v-if="pageType==='material'"></el-table-column>
      <el-table-column prop="product.attr2" label="克重" align="center"
                       header-align="center" v-if="pageType==='material'"></el-table-column>
      <el-table-column prop="product.nameZh" label="中文品名" align="center"
                       header-align="center" v-if="pageType==='product'"></el-table-column>

      <el-table-column prop="price" label="开票单价" align="center" width="100" header-align="center" fixed="right">
      </el-table-column>
      <el-table-column prop="count" label="数量" align="center" header-align="center" width="100" fixed="right">
      </el-table-column>
      <el-table-column prop="totalAmount" label="金额" align="center" width="100" header-align="center" fixed="right"
                       :formatter="$c.prettyNumFormatter">
      </el-table-column>
      <el-table-column prop="auditStatus" width="100" label="审核状态" align="center" header-align="center"
                       fixed="right">
        <template #default="{row}">
          <el-tag type="warning" v-if="row.auditStatus===0">未审核</el-tag>
          <el-tag type="primary" v-else-if="row.auditStatus===10">已通过</el-tag>
          <el-tag type="danger" v-else-if="row.auditStatus===20">未通过</el-tag>
        </template>
      </el-table-column>
            <el-table-column  width="160" label="操作" align="center" header-align="center" fixed="right">
              <template #default="{row}">
<!--                <el-button type="text" icon="el-icon-view">查看单据</el-button>-->
                <el-button type="text" icon="el-icon-edit-outline" @click="showDetailEditDialog(row)"  v-if="$hasPermission('erp:receipt:detail:edit')">修改</el-button>
              </template>
            </el-table-column>
    </SweetTable>
    <SaveDialog ref="SaveDialog" @change="getDataList"></SaveDialog>
    <common-upload ref="ProductReceiptImport" template-url="/static/template/加工费发票导入.xlsx"
                   upload-url="/erp/receipt/import/product" version="v2"
                   placeHolder="请严格按核价单导出EXCEL进行填写" @success="$refs.table.reload()"></common-upload>
    <DetailEditDialog ref="DetailEditDialog"  @changed="getDataList"></DetailEditDialog>
  </div>
</template>

<script>
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'
import SaveDialog from '@/views/modules/erp/receipt/save-dialog.vue'
import DetailEditDialog from '@/views/modules/erp/receipt/detail-edit-dialog.vue'

export default {
  name: 'ReceiptDetailTable',
  mixins: [SweetTable],
  components: { DetailEditDialog, SaveDialog },
  data () {
    return {
      pageType: '',
      dataForm: {
        sellerName: '',
        receiptCode: '',
        orderCode: '',
        productCode: '',
        skuCode: '',
        nameZh: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        productType: ''
      },
    }
  },
  computed: {
    productNameLabel () {
      return this.pageType === 'product' ? '品名' : '物料名称'
    }
  },
  activated () {
    this.pageType = this.$route.params.type
    this.dataForm.productType = this.pageType
    this.reload()
  },
  methods: {
    showDetailEditDialog (row) {
      this.$refs.DetailEditDialog.init(row)
    },
    showSaveDialog () {
      this.$refs.SaveDialog.init()
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.totalAmount = new BigNumber(row.count).multipliedBy(row.price).toFixed(5)
      })
    }
  }
}
</script>

<style scoped>

</style>
